const USER_AGENT = navigator.userAgent.toLowerCase();

const isInApp = /Leedarson/i.test(navigator.userAgent);

const isIos = /iphone|ipad|ipod/.test(USER_AGENT);
const isAndroid = /android/.test(USER_AGENT);

const isMobile = isIos || isAndroid;

const isInIosApp = isInApp && isIos;

export { isInApp, isIos, isAndroid, isMobile, isInIosApp };
